import * as React from "react";
import { PaginationProvider, useModalContext } from "common/contexts";
import useFeature from "hooks/useFeature";
import MachineForm from "./MachineForm";
import UserForm from "./UserForm";
import AssetDetailsDrawer from "./AssetDetailsDrawer";
function AssetModals() {
  const { modal, setModal, entity, setEntity } = useModalContext();
  const isRightSidebarEnabled = useFeature("asset_right_sidebar");
  const onClose = () => {
    if (entity == null ? void 0 : entity.fromDetails) {
      setModal("ASSET-DETAILS");
    } else {
      setModal(null);
      setEntity(null);
    }
  };
  switch (modal) {
    case "MACHINE-FORM":
      return /* @__PURE__ */ React.createElement(MachineForm, { asset: entity == null ? void 0 : entity.asset, show: true, onClose });
    case "USER-FORM":
      return /* @__PURE__ */ React.createElement(UserForm, { asset: entity == null ? void 0 : entity.asset, show: true, onClose });
    case "ASSET-DETAILS":
      if (isRightSidebarEnabled) return null;
      return /* @__PURE__ */ React.createElement(PaginationProvider, null, /* @__PURE__ */ React.createElement(
        AssetDetailsDrawer,
        {
          asset: entity == null ? void 0 : entity.asset,
          onClose: () => {
            setModal(null);
            setEntity(null);
          }
        }
      ));
    default:
      return null;
  }
}
export default AssetModals;
